module.exports = __webpack_public_path__ + "img/footer-logos.e3940173.png";